import React from "react";
import { CircularProgress } from '@mui/material'; 
import "./index.css";


const Loading = ({  isLoading }) => {
  return (
      <div className="loading">
        {isLoading ? 
              <CircularProgress aria-label="Loading data" color="inherit" size="8rem" />
        :
              ('')
        }
      </div>
  );
}

export default Loading;
